const SENTRY_LEVEL = Object.freeze({
  fatal: 'fatal',
  error: 'error',
  warning: 'warning',
  log: 'log',
  info: 'info',
  debug: 'debug',
});

export default SENTRY_LEVEL;
